import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { resolveChatMessagingUiEnabled } from '@/shared/composables/user-features'
import { pathNames } from '@/shared/utils/constants'
import { getChatRoute } from '@/shared/utils/url'

import { setCallSessionPropsResolver } from './lazy-route-props'

const mainRoute = { name: pathNames.MAIN }

export const callSessionBeforeEnter = async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const [
    { useCallSessionRoomStore },
    { STATE, useWebRTC },
    { callSessionPropsFn },
  ] = await Promise.all([
    import('@/entities/call-session'),
    import('@/entities/webrtc'),
    import('./callSessionPropsFn'),
  ])
  setCallSessionPropsResolver(callSessionPropsFn)

  const isAnsweredSessionState = (state: unknown) => (
    state === STATE.CONNECTED || state === STATE.ONHOLD
  )

  const { sessionId } = to.params

  if (!sessionId) {
    next(mainRoute)
  } else if (typeof sessionId === 'string') {
    const { getRTCSessionFacadeById } = useWebRTC()
    const facade = getRTCSessionFacadeById(sessionId)

    if (!facade) {
      next(mainRoute)
      return
    }

    if (!isAnsweredSessionState(facade.sessionState.value)) {
      const room = useCallSessionRoomStore().getRoom(sessionId)
      const chatRoute = room ? getChatRoute(room) : null
      if (chatRoute && resolveChatMessagingUiEnabled()) {
        next(chatRoute)
        return
      }

      next(mainRoute)
      return
    }

    if (!to.meta) {
      to.meta = {}
    }
    to.meta.callSessionProps = callSessionPropsFn(to)
    next()
  } else {
    next(mainRoute)
  }
}
